import { UnitType } from '@src/core/enums';
import { getUnitType } from '@src/core/features/settings/units';

/**
 * Safety clearance radius shown in preflight checklists. The value is unit-native
 * (a round, memorable figure per system) rather than a hard-converted number, so it
 * never renders as "9.84 ft". Reactive: callers read it under useUnitType() so it
 * re-renders on a live unit switch instead of staying hardcoded "10 ft".
 */
export const safeDistanceLabel = (unitType: UnitType = getUnitType()): string =>
  unitType === UnitType.IMPERIAL ? '10 ft' : '3 m';
